const LightbulbIllustration = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 260 282'
      fill='none'
      className={className}
      aria-hidden='true'
      focusable='false'
    >
      <path
        stroke='#FF620F'
        strokeWidth='16'
        d='M187.298 230.923c6.905 11.929 31.61 25.612 45.676 11.914 14.066-13.699 10.013-23.201 6.81-26.235-3.203-3.034-9.95-4.691-18.816.992-8.865 5.683-32.946 39.58-21.113 60.023'
      />
      <path
        fill='#FC3'
        d='M187.847 172.666c-4.764-9.806-4.722-21.231.012-31.052 14.64-30.377 13.265-67.464-6.873-97.514-10.136-15.126-23.744-26.547-39.061-33.927-.489-.236-.98-.47-1.473-.697-29.929-13.818-66.088-12.36-95.637 6.927C-.622 46.062-13.503 107.517 16.26 152.822c20.135 30.65 54.4 46.38 88.528 44.37 10.83-.637 21.325 3.887 28.538 11.971l.445.499a9.977 9.977 0 0 0 12.974 1.655l11.501-7.668 1.328-.887 25.191-16.795a9.92 9.92 0 0 0 3.428-12.591l-.345-.71Z'
      />
      <path
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2.479'
        d='M99.63 112.79c5.945 8.873 3.554 20.874-5.341 26.805-8.896 5.931-20.927 3.546-26.873-5.327-5.946-8.873-3.554-20.874 5.34-26.805 8.896-5.931 20.927-3.546 26.873 5.327ZM144.19 83.08c5.946 8.872 3.554 20.873-5.341 26.804-8.895 5.931-20.926 3.546-26.872-5.327-5.946-8.873-3.555-20.874 5.34-26.805 8.896-5.93 20.927-3.546 26.873 5.327Z'
      />
      <path
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='2.479'
        d='M121.91 97.935c5.945 8.873 3.554 20.873-5.341 26.804-8.895 5.932-20.926 3.547-26.872-5.326-5.946-8.873-3.555-20.874 5.34-26.805 8.896-5.931 20.927-3.546 26.873 5.327ZM146.871 88.989l33.675 103.238M154.3 209.516l-81.215-69.649'
      />
      <path
        fill='#B5B5B5'
        d='m195.696 213.529-27.599 18.402c-3.43 2.287-8.068 1.367-10.36-2.054l-11.992-17.894 40.019-26.683 11.992 17.894a7.44 7.44 0 0 1-2.06 10.335Z'
      />
      <path
        fill='#949494'
        d='m192.586 229.544-8.464 5.644a11.643 11.643 0 0 1-13.383-.33l-3.332-2.467 28.979-19.321 1.011 4.014a11.575 11.575 0 0 1-4.811 12.46Z'
      />
    </svg>
  );
};
export default LightbulbIllustration;
